
import React from "react";
import { Navigate } from "react-router-dom";
import OnboardingLayout from "@/layouts/OnboardingLayout";
import { useAuth } from "@/hooks/useAuth";
import { debugLogger } from '@/utils/debugLogger';
import { Button } from "@/components/ui/button";
import { RefreshCw, AlertCircle, Loader } from "lucide-react";

const ProtectedOnboardingLayout: React.FC = () => {
  const { user, loading, error, retry } = useAuth();
  
  debugLogger.debug('ProtectedOnboardingLayout - Render:', { 
    hasUser: !!user,
    loading,
    error,
    currentPath: window.location.pathname
  });

  // Se tem usuário, mostrar OnboardingLayout
  if (user) {
    debugLogger.debug('ProtectedOnboardingLayout - User found, rendering OnboardingLayout');
    return <OnboardingLayout />;
  }

  // Se tem erro, mostrar tela de erro
  if (error) {
    debugLogger.debug('ProtectedOnboardingLayout - Showing error state:', error);
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-6">
          <div className="mb-6">
            <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-white mb-2">Erro de Autenticação</h2>
            <p className="text-gray-400 mb-6">{error}</p>
          </div>
          
          <Button 
            onClick={retry}
            className="w-full bg-luxury-red hover:bg-luxury-red/80 text-white"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Tentar Novamente
          </Button>
          
          <Button 
            variant="ghost" 
            onClick={() => window.location.href = '/auth'}
            className="w-full mt-3 text-gray-400 hover:text-white"
          >
            Voltar ao Login
          </Button>
        </div>
      </div>
    );
  }

  // Se está loading, mostrar loading
  if (loading) {
    debugLogger.debug('ProtectedOnboardingLayout - Showing loading state');
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-6">
          <Loader className="h-16 w-16 text-luxury-red mx-auto mb-4 animate-spin" />
          <h2 className="text-xl font-semibold text-white mb-2">Verificando autenticação...</h2>
          <p className="text-gray-400">Aguarde um momento</p>
        </div>
      </div>
    );
  }

  // Se não tem usuário e não está loading, redirecionar
  debugLogger.debug('ProtectedOnboardingLayout - No user and not loading, redirecting to auth');
  return <Navigate to="/auth" replace />;
};

export default ProtectedOnboardingLayout;
